import { render, staticRenderFns } from "./BtDimsDimModel.vue?vue&type=template&id=340b0237&scoped=true&"
import script from "./BtDimsDimModel.vue?vue&type=script&lang=js&"
export * from "./BtDimsDimModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340b0237",
  null
  
)

export default component.exports